import axios from "axios"

export default {
  state: () => ({
    entities: [],
    activeEntity: null,
  }),
  getters: {
    getAll: (state) => state.entities,
    getActive: (state) => state.activeEntity,
    getById: (state) => (id) => state.entities.find(project => project.id === id),
  },
  mutations: {
    setProjects(state, projects) {
      state.entities = projects
    },
    setActiveProject(state, project) {
      state.activeEntity = project
    },
    updateProject(state, {folderId, fileId, data}) {
      //TODO projects store update mutation
    },
    deleteProject(state, projectId) {
      const temp = state.entities
      const projectIndexToDelete = state.entities.findIndex(project => project.id === projectId)

      if (projectIndexToDelete >= 0) {
        temp.splice(projectIndexToDelete, 1)
      }

      state.entities = temp
    },
  },
  actions: {
    async fetchAll({ commit, rootState }) {
      axios.defaults.headers.common["Authorization"] = "Bearer " + rootState.auth.token;
      const projects = (await axios.get("/projects")).data
      // console.log(projects)
      projects.forEach(project => {
        project.created_at = new Date(project.created_at).toLocaleDateString()
        project.updated_at = new Date(project.updated_at).toLocaleDateString()
        project.start_date = new Date(project.start_date)
        project.end_date = new Date(project.end_date)
      })

      commit("setProjects", projects)
    },
    async fetchById({ commit, rootState }, projectId) {
      axios.defaults.headers.common["Authorization"] = "Bearer " + rootState.auth.token;
      const project = (await axios.get(`projects/${projectId}`)).data
      project.created_at = new Date(project.created_at)
      project.updated_at = new Date(project.updated_at)
      project.start_date = new Date(project.start_date)
      project.end_date = new Date(project.end_date)

      commit("setActiveProject", project)
    },
    async save({ commit, state }, project) {
      axios.defaults.headers.common["Authorization"] = "Bearer " + rootState.auth.token;
      // return axios.post("/projects", project)
    },
    async update({ commit, state }, project) {
      await axios.put(`projects/${state.activeEntity.id}`, project)
    },
    async addMembersToActiveProject({ commit, state }, members) {
      members.forEach(async (member) => {
        await axios.post(`projects/${state.activeEntity.id}/member/add`, member)
      })
    },
    async updateMembersOfActiveProject({ commit, state }, members) {
      members.forEach(async (member) => {
        await axios.put(`projects/${state.activeEntity.id}/member/${member.id}/update_role`, member)
      })
    },
    async removeMembersOfActiveProject({ commit, state }, members) {
      members.forEach(async (member) => {
        await axios.delete(`projects/${state.activeEntity.id}/member/${member.id}`)
      })
    },

    async delete(context, projectId) {
      await axios.delete(`projects/${projectId}/archive`)
      await axios.delete(`projects/${projectId}`)
      context.commit("deleteProject", projectId)
    },
  },
}
